import config from "@/config"
import http from "@/utils/request"

export default {
	getList: {
		url: `${config.API_URL}/template/getList`,
		name: "创作列表",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
	},
	save: {
		url: `${config.API_URL}/template/save`,   //task_type 1 普通  2 智能
		name: "新增模板",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		}
	},

    delete: {
		url: `${config.API_URL}/template/delete`,
		name: "删除",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
	},

    getMusicTags: {
		url: `${config.API_URL}/template/getMusicTags`,
		name: "背景音乐标签",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
	},

    getMusicList: {
		url: `${config.API_URL}/template/getMusicList`,
		name: "背景音乐列表",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
	},

	getConfig: {
		url: `${config.API_URL}/template/getConfig`,
		name: "获取模板剪辑配置信息",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
	},
}
